import ICMAxios from "../ICMAxios";
import { ITagDetailsByUserRequest, ITagsByLocationRequest, IUpdateReconcileDetailsRequest } from "../../interfaces";

const TagService = {
    // Add a new tag
    addTagAsync: (tagRequest: any) =>
        ICMAxios.post('v1/Tag', tagRequest),

    // Get tags by user ID
    getTagByUserIdAsync: (requestViewModel: ITagDetailsByUserRequest) =>
        ICMAxios.post('v1/Tag/tags', requestViewModel),

    // Get tag detailsAnyNaptrRecord by location ID
    getTagDetailsAsync: (requestViewModel: ITagsByLocationRequest) =>
        ICMAxios.post('v1/Tag/tagdetails', requestViewModel),

    // Update an existing tag
    updateTagAsync: (updateTagsRequestView: any) =>
        ICMAxios.put('v1/Tag', updateTagsRequestView),

    // Fetch items by client ID
    getItemsByClientIdAsync: () =>
        ICMAxios.get(`v1/Item/itemtags`),

    // Fetch UOM tags by item ID
    getItemUOMAsync: (itemId: number) =>
        ICMAxios.get(`v1/Item/${itemId}/itemuomtags`),

    // Fetch locations by area ID
    getAreaWithLocationAsync: (locationWithAreaRequestViewModel: any) =>
        ICMAxios.post(`v1/Location/getAreas`, locationWithAreaRequestViewModel),

    // Fetch locations by client ID
    getLocationsByClientIdAsync: () =>
        ICMAxios.get(`v1/Location`),

    getActiveAreasWithPaginationAsync: (clientId: number, pageIndex: number, pageSize: number, isReconciledTags: boolean, isPendingReconcileTags: boolean, isToBeCounted: boolean, isCountedTags: boolean, isPendingAuditTags: boolean, isAuditedTags: boolean, searchText: string | null, inventoryId:number, listUser:any) =>
        ICMAxios.post(`v1/Inventory/${inventoryId}/areas`, {
            pageIndex,
            pageSize,
            searchText,
            isReconciledTags,
            isPendingReconcileTags,
            isToBeCounted,
            isCountedTags,
            isPendingAuditTags,
            isAuditedTags,
            clientId,
            listUser
        }),

    getActiveLocationsWithPaginationAsync: (areaId: number, pageIndex: number, pageSize: number, isReconciledTags: boolean, isPendingReconcileTags: boolean, isToBeCounted: boolean, isCountedTags: boolean, isPendingAuditTags: boolean, isAuditedTags: boolean, searchText: string | null, inventoryId:number, listUser:any) =>
        ICMAxios.post(`v1/Inventory/${inventoryId}/locations`, {
            pageIndex,
            pageSize,
            searchText,
            isReconciledTags,
            isPendingReconcileTags,
            isToBeCounted,
            isCountedTags,
            isPendingAuditTags,
            isAuditedTags,
            areaId,
            listUser
        }),

    getActiveTagsWithPaginationAsync: (locationId: number, pageIndex: number, pageSize: number, isReconciledTags: boolean, isPendingReconcileTags: boolean, isToBeCounted: boolean, isCountedTags: boolean, isPendingAuditTags: boolean, isAuditedTags: boolean, searchText: string | null, inventoryId: number, listUser:any) =>
        ICMAxios.post(`v1/Inventory/${inventoryId}/tags`, {
            locationId,
            pageIndex,
            pageSize,
            isReconciledTags,
            isPendingReconcileTags,
            isToBeCounted,
            isCountedTags,
            isPendingAuditTags,
            isAuditedTags,
            searchText,
            listUser
    }),

    getReconciliationTagAsync: (tagId: number) =>
        ICMAxios.get(`v1/Inventory/tags/${tagId}`),

    updateReconcileDetailsRequest: (requestViewModel: IUpdateReconcileDetailsRequest) =>
        ICMAxios.put('v1/Tag/reconciledetails', requestViewModel),
    assigneAuditor: (data: any) =>
        ICMAxios.post('v1/Tag/generate-audit', data),

};

export default TagService;
